import React, { Component } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Position, Tooltip } from "@blueprintjs/core";
import { Icons } from "prefab";
import { TablePagination } from "workbench";
import Collapsible from "../../../../common/Collapsible";
import FilterChips from "../../../../common/Filters/FilterChips";
import Filters from "../../../../common/Filters/Filters";
import Selector from "../../../../common/Selector";
import StatusIcon from "../../../../common/StatusIcon";
import { getCategory } from "../../../../../utils";
import formatValidityPeriodDisplay from "../../../../../utils/formatValidityPeriodDisplay";
import CampaignTree from "../../CampaignStructure/CampaignTree";
import ButtonStyle from "../../../../../styles/Button.module.scss";
import styles from "../../../../../styles/Campaigns/Campaigns.module.scss";
import tooltipStyles from "../../../../../styles/ToolTip.module.scss";
import Popup from "../../../../common/Popup";
import PageLoadingWithTable from "../../../../common/PageLoadingWithTable";
import InfoBlockLoading from "../../../../common/InfoBlockLoading";
import LocalizedButton from "../../../../common/LocalizedButton";
import InfoBlock from "../../../../common/InfoBlock";
import { MediaPlacements } from "../../utils";
import {
  CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST,
  CAMPAIGN_ACTIONS,
  CAMPAIGN_STATUS_LIST,
  TAG_TYPE,
} from "../../../../../constants";
import { isDeleteEnabled } from "../../../../../utils/campaigns";

const { EditIcon, DeleteIcon, CopyIcon, ChevronDownIcon, SearchIcon, CancelIcon } = Icons;

const renderContentNameTooltip = (contentName, isExpanded = false) => (
  <Tooltip
    className={tooltipStyles.toolTip}
    position={Position.AUTO}
    content={<div style={{ maxWidth: "250px", wordBreak: "break-word" }}>{contentName}</div>}
    usePortal={true}
    hoverOpenDelay={300}
    popoverClassName={tooltipStyles.nonInteractivePopover}
    portalClassName={tooltipStyles.nonInteractivePopover}
    modifiers={isExpanded ? { offset: { offset: "0, 8" } } : undefined}
  >
    <span className={styles.contentName}>{contentName}</span>
  </Tooltip>
);

const renderMediaNameTooltip = (name) => (
  <Tooltip
    className={classNames(tooltipStyles.toolTip, styles.listItemTooltip)}
    position={Position.AUTO}
    content={<div style={{ maxWidth: "250px", wordBreak: "break-word" }}>{name}</div>}
    usePortal={true}
    hoverOpenDelay={300}
  >
    <span className={styles.listItemName}>{name}</span>
  </Tooltip>
);

const MEDIA_FILTER_TAG_TYPES = [
  TAG_TYPE.CONTENT,
  TAG_TYPE.SEGMENT_TYPE,
  TAG_TYPE.POSITION,
  TAG_TYPE.PLAYLIST_PACK,
  TAG_TYPE.THEATRE,
  TAG_TYPE.SCREEN,
  TAG_TYPE.TARGET_GROUP,
  TAG_TYPE.MEDIA_STATUS,
  TAG_TYPE.VALIDITY,
];
const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];

export default class MediaDetails extends Component {
  static propTypes = {
    mediaList: PropTypes.array.isRequired,
    withCampaignTree: PropTypes.bool,
    showEstimates: PropTypes.bool,
    showAdd: PropTypes.bool,
    showEdit: PropTypes.bool,
    showDuplicate: PropTypes.bool,
    showDelete: PropTypes.bool,
    serverBacked: PropTypes.bool,
    totalCount: PropTypes.number,
    page: PropTypes.number,
    ps: PropTypes.number,
    filters: PropTypes.array,
    searchQuery: PropTypes.string,
    onSearchChange: PropTypes.func,
    onFilterChange: PropTypes.func,
    onQueryChange: PropTypes.func,
  };

  static defaultProps = {
    showAdd: false,
    showEstimates: false,
    withCampaignTree: false,
    showEdit: true,
    showDuplicate: true,
    showDelete: true,
    serverBacked: false,
    totalCount: 0,
    page: 1,
    ps: 100,
    filters: [],
    searchQuery: "",
  };

  state = {
    isPopupOpen: false,
    isCampaignStructureLoading: true,
    campaignStructure: {},
    isCampaignStructureError: false,
    searchQuery: "",
  };

  componentDidMount = async () => {
    //  if (this.props.withCampaignTree) await this.fetchCampaignTreeData();
  };

  // fetchCampaignTreeData = () => {
  //   const { params } = this.props;

  //   getCampaignTreeApi(params.campaignId)
  //     .then((campaignRes) =>
  //       this.setState({
  //         isCampaignStructureLoading: false,
  //         campaignStructure: campaignRes,
  //       })
  //     )
  //     .catch((err) => {
  //       this.setState({
  //         isCampaignStructureLoading: false,
  //         isCampaignStructureError: true,
  //         campaignStructure: null,
  //       });
  //     });
  // };

  handleEditClick = (event, id) => {
    event.stopPropagation();
    if (this.props.onEdit) {
      this.props.onEdit(id);
    }
  };

  handleDuplicateClick = (event, id) => {
    event.stopPropagation();
    if (this.props.onDuplicate) {
      this.props.onDuplicate(id);
    }
  };

  handleMediaCreate = (event) => {
    event.stopPropagation();
    if (this.props.onMediaCreate) {
      this.props.onMediaCreate();
    }
  };

  handleConfirmDelete = (event) => {
    event.stopPropagation();
    if (this.props.onDelete) {
      this.props.onDelete(this.state.selectedId);
    }

    this.setState({
      isPopupOpen: false,
    });
  };

  handleDeleteClick = (event, id) => {
    event.stopPropagation();

    this.setState({
      isPopupOpen: true,
      selectedId: id,
    });
  };

  onDiscardChanges = (event) => {
    event.stopPropagation();

    this.setState({
      isPopupOpen: false,
    });
  };

  renderInfoBlockDetails = (media, timesOfDay) => {
    const { campaignMedia, isDetailsLoading } = this.props;
    if (isDetailsLoading) return <InfoBlockLoading />;

    if (campaignMedia?.billableWeeklyPlayCount && media.id === campaignMedia?.id) {
      media.billableWeeklyPlayCount = campaignMedia.billableWeeklyPlayCount;
    }

    return (
      <div className={styles.collapsibleBodyContainer}>
        <InfoBlock
          hideHeader
          config={[
            {
              title: "Content",
              value: media.contentId ? (
                renderContentNameTooltip(media.contentName, true)
              ) : (
                <LocalizedButton
                  id="add"
                  className={`${styles.addButton}`}
                  iconName="AddIcon"
                  onClick={(event) => this.handleEditClick(event, media.id)}
                  text="Button.add"
                />
              ),
              size: {
                lg: 4,
                md: 4,
                sm: 12,
              },
            },
            {
              title: "Content Type",
              value: media.contentTypeName,
              size: {
                lg: 4,
                md: 4,
                sm: 12,
              },
            },
            {
              title: "Duration",
              value: `${media.contentDurationInSeconds || 0} Seconds`,
              size: {
                lg: 4,
                md: 4,
                sm: 12,
              },
            },
            {
              title: "Brand",
              value: media.brandName,
              size: {
                lg: 4,
                md: 4,
                sm: 12,
              },
            },
            {
              title: "Category",
              value: media.categories
                ? media.categories.map((category, key) => (
                    <div key={key}>{getCategory(category)}</div>
                  ))
                : "",
              size: {
                lg: 4,
                md: 4,
                sm: 12,
              },
            },
            {
              title: "Thirdparty Media ID",
              value: media.thirdpartyMediaId,
              size: {
                lg: 4,
                md: 4,
                sm: 12,
              },
            },
            {
              title: "Media No.",
              value: media.mediaNumber,
              size: {
                lg: 4,
                md: 4,
                sm: 12,
              },
            },
          ]}
        />
        {media.placements && <MediaPlacements media={media} timesOfDay={timesOfDay} />}
      </div>
    );
  };

  render() {
    const {
      mediaList,
      timesOfDay,
      showDelete,
      showDuplicate,
      showEdit,
      showAdd,
      withCampaignTree,
      isLoading,
      getMediaDetails,
      params: { campaignId } = {},
      serverBacked,
      totalCount,
      page,
      ps,
      filters,
      searchQuery: remoteSearchQuery,
      onSearchChange,
      onFilterChange,
      onQueryChange,
    } = this.props;
    const { isPopupOpen, isCampaignStructureError } = this.state;
    const searchQuery = serverBacked ? remoteSearchQuery : this.state.searchQuery;

    if (isLoading && !serverBacked) return <PageLoadingWithTable />;

    const displayedMediaList = serverBacked
      ? mediaList
      : mediaList.filter((media) => media.name.toLowerCase().includes(searchQuery.toLowerCase()));
    const displayedTotalCount = serverBacked ? totalCount : displayedMediaList.length;
    const pageStart = (page - 1) * ps;
    const pageEnd = Math.min(pageStart + displayedMediaList.length, displayedTotalCount);

    return (
      <>
        <div className="col-12 clearfix flex">
          <div className={classNames("col-12", styles.listContent)}>
            <div className={styles.listHeader}>
              <div className={styles.listHeaderLeft}>
                <div className={styles.listHeaderTitle}>
                  <FormattedMessage id="PageHeader.media" defaultMessage="Media" />
                  <span className={styles.countBadge}>{displayedTotalCount}</span>
                </div>
                <div className={styles.searchWrapper}>
                  <input
                    className={styles.searchInput}
                    placeholder="Search Media"
                    aria-label="Search Media"
                    value={searchQuery}
                    onChange={(e) =>
                      serverBacked
                        ? onSearchChange(e.target.value)
                        : this.setState({ searchQuery: e.target.value })
                    }
                  />
                  {searchQuery && (
                    <button
                      type="button"
                      className={styles.searchClearButton}
                      aria-label="Clear media search"
                      onClick={() =>
                        serverBacked ? onSearchChange("") : this.setState({ searchQuery: "" })
                      }
                    >
                      <CancelIcon />
                    </button>
                  )}
                  <span
                    className={classNames(styles.searchIconWrapper, {
                      [styles.searchIconWithClear]: Boolean(searchQuery),
                    })}
                  >
                    <SearchIcon />
                  </span>
                </div>
                {serverBacked && (
                  <div className={styles.filterControl}>
                    <Filters
                      tagTypes={MEDIA_FILTER_TAG_TYPES}
                      selected={filters}
                      onFilterChange={onFilterChange}
                    />
                    {filters.length > 0 && (
                      <span
                        className={styles.filterCount}
                        aria-label={`Filter (${filters.length})`}
                      >
                        {filters.length}
                      </span>
                    )}
                  </div>
                )}
              </div>
              {showAdd && (
                <LocalizedButton
                  text="Button.createMedia"
                  iconName="AddFilledIcon"
                  onClick={(event) => this.handleMediaCreate(event)}
                  className={`${ButtonStyle.addButton} ${styles.listHeaderAddButton}`}
                />
              )}
            </div>
            {serverBacked && (
              <FilterChips
                selected={filters}
                clearLabel="Clear All"
                onFilterChange={onFilterChange}
              />
            )}
            {displayedMediaList.length === 0 && (
              <div className={styles.noSearchResults}>
                {serverBacked
                  ? "No results found. Try adjusting your search or filters."
                  : "No results found"}
              </div>
            )}
            {displayedMediaList.map((media) => {
              const statusDetails = CAMPAIGN_STATUS_LIST.find((s) => s.id === media.status);
              return (
                <Collapsible
                  key={media.id}
                  header={(isOpen, toggleCollapse) => (
                    <div
                      className={classNames(styles.collapsibleHeaderContainer, styles.mediaHeader)}
                      onClick={() => {
                        getMediaDetails(media.id, "list");
                        toggleCollapse();
                      }}
                    >
                      <div className={styles.title}>
                        <span
                          className={classNames(styles.icon, {
                            [styles.open]: isOpen,
                            [styles.close]: !isOpen,
                          })}
                        >
                          <ChevronDownIcon />
                        </span>
                        <div className={styles.contentInfoWrapper}>
                          <div className={styles.mediaTitleRow}>
                            {renderMediaNameTooltip(media.name)}
                            {statusDetails && (
                              <span className={styles.mediaStatusBadge}>
                                <StatusIcon color={statusDetails.color} />
                                <span>{statusDetails.displayName}</span>
                              </span>
                            )}
                          </div>
                          {media.contentName && (
                            <div className={styles.contentNameRow}>
                              {renderContentNameTooltip(media.contentName)}
                              <span
                                className={classNames(
                                  styles.availabilityPill,
                                  media.contentId
                                    ? styles.availabilityPillAvailable
                                    : styles.availabilityPillNotAvailable
                                )}
                              >
                                {media.contentId ? "Available" : "Not Available"}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={classNames(styles.subTitle, styles.mediaSubTitle)}>
                        <div className={styles.info}>
                          <div>
                            <strong>Target Group</strong>
                          </div>
                          <div className={styles.targetGroupNameRow}>
                            {media.targetGroupName && renderMediaNameTooltip(media.targetGroupName)}
                            <span className={styles.screenCount}>
                              {media.noOfScreens ? `${media.noOfScreens} Screens` : ""}
                            </span>
                          </div>
                        </div>
                        <div className={styles.info}>
                          <div>
                            <strong>Duration</strong>
                          </div>
                          <div>{formatValidityPeriodDisplay(media?.validity, "DD MMM YYYY")}</div>
                        </div>
                      </div>
                      <div className={styles.collapseActions}>
                        {showEdit &&
                          CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST[CAMPAIGN_ACTIONS.EDIT].includes(
                            media.status
                          ) && (
                            <div
                              className={styles.button}
                              onClick={(event) => this.handleEditClick(event, media.id)}
                            >
                              <EditIcon />
                            </div>
                          )}
                        {showDuplicate && (
                          <div
                            className={styles.button}
                            onClick={(event) => this.handleDuplicateClick(event, media.id)}
                          >
                            <CopyIcon />
                          </div>
                        )}
                        {showDelete && (
                          <div
                            className={
                              isDeleteEnabled(media, this.props.campaign?.status)
                                ? styles.button
                                : styles.disabledBtn
                            }
                            onClick={(event) => {
                              if (isDeleteEnabled(media, this.props.campaign?.status)) {
                                this.handleDeleteClick(event, media.id);
                              } else {
                                event.stopPropagation();
                              }
                            }}
                          >
                            <DeleteIcon />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  body={(isOpen) => this.renderInfoBlockDetails(media, timesOfDay)}
                />
              );
            })}
            {serverBacked && (
              <div className={styles.paginationFooter}>
                <span className={styles.paginationSummary}>
                  {displayedTotalCount === 0
                    ? "Showing 0 of 0"
                    : `Showing ${pageStart + 1}-${pageEnd} of ${displayedTotalCount}`}
                </span>
                <div className={styles.paginationControls}>
                  <div className={styles.pageSizeSelector}>
                    <Selector
                      showLabelInButton={false}
                      singleSelect
                      selectedList={[ps]}
                      onSelect={(value) => onQueryChange("ps", value)}
                      list={PAGE_SIZE_OPTIONS}
                      placeHolder="Show"
                      usePortal={false}
                    />
                  </div>
                  <TablePagination
                    totalRecords={displayedTotalCount}
                    pageSize={ps}
                    pageNeighbours={1}
                    onPageChange={(value) => onQueryChange("page", value)}
                    currentPage={page}
                  />
                </div>
              </div>
            )}
          </div>
          {withCampaignTree && !isCampaignStructureError && (
            <div className={styles.campaignTree}>
              <CampaignTree
                // isLoading={isCampaignStructureLoading}
                // campaignTreeData={campaignStructure ?? []}
                campaignIdForSummary={campaignId}
              />
            </div>
          )}
        </div>
        <Popup
          isOpen={isPopupOpen}
          onClose={this.onDiscardChanges}
          onConfirm={this.handleConfirmDelete}
          title="Popup.title"
          body="Popup.body"
        />
      </>
    );
  }
}
